<template>
    <header>
        <b-navbar toggleable="lg" type="light" variant="faded">
            <div class="container">
                <b-navbar-brand to="/">
                    <b-img :src="logo" :alt="name" :title="name"/>
                </b-navbar-brand>
                <b-collapse id="nav-collapse" is-nav>
                    <b-navbar-nav>
                        <b-nav-item to="/">首页</b-nav-item>
<!--                        <b-nav-item to="/found">发现</b-nav-item>-->
                        <b-nav-item to="/teacher/course" v-permission="['teacher']">开始上课</b-nav-item>
                        <b-nav-item to="/activity">社区活动</b-nav-item>
                        <b-nav-item to="/exam" v-permission="['teacher', 'user']">竞赛活动</b-nav-item>
                    </b-navbar-nav>

                    <b-navbar-nav class="ml-auto align-items-center">
                        <div class="dropdown create mr-2">
                            <button type="button" class="create-btn">创作</button>
                            <ul class="dropdown-menu create-dropdown-menu">
                                <b-nav-item class="create-a" href="/scratch">图 形 化 编 程</b-nav-item>
                                <b-nav-item class="create-a" href="/python">Python编辑器</b-nav-item>
                            </ul>
                        </div>

                        <b-nav-item to="/notice" v-show="is_login">
                            <b-icon icon="bell-fill" variant="white" font-scale="1.5"/>
                        </b-nav-item>

                        <b-nav-item-dropdown right v-show="is_login">
                            <template v-slot:button-content>
                                <b-img class="user-icon" :src="avatar"/>
                            </template>
                            <b-dropdown-item to="/user/project">我的项目</b-dropdown-item>
                            <b-dropdown-item :to="`/user/zone/${uid}`">个人主页</b-dropdown-item>
                            <b-dropdown-item to="/user/settings">账号设置</b-dropdown-item>
                            <b-dropdown-divider></b-dropdown-divider>
                            <b-dropdown-item type="button" @click="$store.dispatch('logout')">退出登录</b-dropdown-item>
                        </b-nav-item-dropdown>

                        <b-nav-item v-b-modal:login-modal v-show="!is_login">登录</b-nav-item>
                        <b-nav-item v-b-modal:register-modal v-show="!is_login">注册</b-nav-item>
                    </b-navbar-nav>
                </b-collapse>
            </div>
            <b-navbar-nav class="manager">
                <b-nav-item to="/school" v-permission="['school']">校区管理</b-nav-item>
                <b-nav-item to="/manager" v-permission="['manager']">品牌管理</b-nav-item>
                <b-nav-item to="/backstage" v-permission="['dev']">管理后台</b-nav-item>
            </b-navbar-nav>
        </b-navbar>
    </header>
</template>

<script>
import {mapGetters} from "vuex";

export default {
    name: "Head",
    async beforeCreate() {
        await this.$store.dispatch('loadApp');
    },
    computed: {
        ...mapGetters(['is_login', "avatar", "username", "uid", "logo", "name"])
    }
}
</script>

<style lang="scss" scoped>
header {
    position: relative;
    height: 72px;

    .manager {
        position: absolute;
        top: 15px;
        right: 30px;
    }

    img {
        height: 50px;
    }

    .nav-item {
        margin-left: 20px;
    }

    .nav-link {
        padding: 8px 20px !important;
        font-size: 18px;
        border-radius: 25px;
        color: #fff !important;
        font-weight: bold;
        transition: all .15s ease;
    }

    .nav-link:hover {
        background: rgba(43, 43, 43, .25);
    }

    .create {
        .create-btn {
            font-size: 24px;
            font-weight: 900;
            background-color: #ff6701 !important;
            border: none;
            padding: 18px 42px 18px 42px;
            color: #fff !important;
            border-radius: 0 0 20px 20px;
        }

        .create-dropdown-menu {
            background-color: #ff6701;
            margin: 0 !important;
            border: none;
            border-radius: 0 0 15px 15px;
            min-width: 132px;
            padding: 5px 0;

            .create-a {
                margin: 0;

                a {
                    width: 100%;
                    color: #fff !important;
                    text-align: center;
                    padding: 10px 18px !important;
                    font-size: 14px;
                    font-weight: 400;
                }
            }
        }
    }

    .create:hover {
        .create-btn {
            border-radius: 0;
        }

        .dropdown-menu {
            display: block;
        }
    }

    .user-icon {
        width: 40px;
        height: 40px;
        border-radius: 8px;
        border: 1px solid #fff;
        background: #fff;
        text-align: center;
    }
}


</style>
